import o from"./document-create-element.js";var r=o,t=r("span").classList,e=t&&t.constructor&&t.constructor.prototype,s=e===Object.prototype?void 0:e;export{s as default};
